import { formatTime } from '../../Dashboard/utils';
import { StatMetric } from './StatMetric';

interface SectorStatItemProps {
  sectorName: string;
  delivered: number;
  notDelivered: number;
  total: number;
  avg: string;
}

export const SectorStatItem = ({
  sectorName,
  delivered,
  notDelivered,
  total,
  avg,
}: SectorStatItemProps) => {
  const isTotal = sectorName === 'total';
  const formattedAvg = formatTime(Number(avg) || 0);

  return (
    <div
      className={`flex flex-col gap-1.5 p-4 rounded-2xl border ${
        isTotal
          ? 'bg-orange-50 border-orange-200 shadow-sm'
          : 'bg-gray-50/80 border-gray-100'
      }`}
    >
      <span
        className={`text-xs uppercase font-black tracking-widest ${
          isTotal ? 'text-orange-600' : 'text-gray-400'
        }`}
      >
        {isTotal ? 'Resumen General' : `Sector ${sectorName}`}
      </span>

      <div className='flex gap-2 items-end justify-between'>
        <StatMetric
          label='Entregados'
          value={delivered}
          valueColorClass='text-green-600'
        />
        <StatMetric
          label='No Entregados'
          value={notDelivered}
          valueColorClass='text-red-600'
        />
        <StatMetric
          label='Total'
          value={total}
          valueColorClass='text-orange-600'
        />
        <StatMetric
          label='Promedio'
          value={formattedAvg.value}
          valueColorClass='text-gray-800'
          unit={formattedAvg.unit}
          hasDivider
        />
      </div>
    </div>
  );
};
